// Pure token analysis (no node imports) — the "unknown token = build error" firewall. Importable
// from anywhere (the CLI audit + unit tests + a lint plugin).
import { TOKEN_NAMES } from "./tokens.js";

const TOKEN_SET = new Set(TOKEN_NAMES);

/** Every `var(--…)` custom-property reference in a blob of CSS/SCSS text, deduped. */
export function referencedTokens(cssText: string): string[] {
  const found = new Set<string>();
  const re = /var\(\s*(--[a-zA-Z0-9-]+)/g;
  let m: RegExpExecArray | null;
  while ((m = re.exec(cssText)) !== null) found.add(m[1]);
  return [...found];
}

/** The subset of referenced custom properties in the design-system namespaces that are NOT registered tokens. */
export function unknownTokens(cssText: string): string[] {
  return referencedTokens(cssText).filter(
    (name) => (name.startsWith("--ac-") || name.startsWith("--bp-")) && !TOKEN_SET.has(name),
  );
}
